<template>
  <div
    v-loading.fullscreen.lock="fullscreenLoading"
    style="border-top: 1px solid #e5e5e5"
  >
    <div class="import-box import_new_wrap">
      <div class="import-title">
        <div class="import-back" @click="$router.go(-1)">返回</div>
        <span>查看完成列表</span>
      </div>
    </div>
    <div class="search-area">
      <el-row :gutter="24">
        <el-col :span="8">
          <div class="search-area-div">客户筛选：</div>
          <el-input
            v-model="page.customerName"
            class="ipt-sty"
            placeholder="请输入"
            :clearable="true"
          ></el-input>
        </el-col>
        <el-col :span="8">
          <div class="search-area-div">采集日期：</div>
          <el-date-picker
            v-model="orderTimeList"
            type="daterange"
            class="ipt-sty"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-col>
        <el-col :span="8">
          <div>
            <el-button size="mini" type="info" @click="search">搜索</el-button>
            <el-button size="mini" type="danger" @click="empty">清空</el-button>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- <div class="back-color-fff content-main-box">
      <div style="text-align:left;padding:12px;">
        <el-button size="mini"  @click="$router.go(-1)">返回</el-button>
      </div> -->
    <div
      class="back-color-fff content-main-box"
      :style="'height:' + contentMainHeight + 'px;'"
    >
      <div class="button-area">
        <el-button size="mini" type="info" @click="delOrder('', 1)">
          批量删除
        </el-button>
      </div>
      <el-table
        ref="filterTable"
        :data="tableData"
        border
        style="width: 100%"
        @selection-change="handleSelectionChange"
        v-loading="loading"
        :height="tableHeight"
        stripe
        :header-cell-style="{ background: '#f4f4f5' }"
      >
        <el-table-column
          type="selection"
          v-if="tableData && tableData.length != 0"
        ></el-table-column>
        <el-table-column
          label="序号"
          width="60"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column
          prop="orderNo"
          width="140"
          label="订单编号"
          show-overflow-tooltip
          header-align="center"
          align="left"
        ></el-table-column>
        <el-table-column
          prop="customerName"
          min-width="200"
          label="客户名称"
          show-overflow-tooltip
          header-align="center"
          align="left"
        ></el-table-column>
        <el-table-column
          prop="inputTime"
          width="120"
          label="采集日期"
          header-align="center"
          align="left"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.inputTime">
              {{ scope.row.inputTime | getDate }}
            </span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="goodsSpecNum"
          width="100"
          label="品种数量"
          header-align="center"
          align="right"
        >
          <template slot-scope="scope">
            {{ scope.row.goodsSpecNum == null ? "-" : scope.row.goodsSpecNum }}
          </template>
        </el-table-column>
        <el-table-column
          prop="totalAmount"
          width="150"
          label="合计金额(元)"
          header-align="center"
          align="right"
        >
          <template slot-scope="scope">
            {{ scope.row.totalAmount | absoluteValue | numFmt | numDigit }}
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          header-align="center"
          align="center"
          width="180"
        >
          <template slot-scope="scope">
            <a class="txt-color" @click="toEdit(scope.row)">编辑 | </a>
            <a class="txt-color" @click="detail(scope.row)">报货详情 | </a>
            <a class="txt-color" @click="delOrder(scope.row)">删除 </a>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      class="pt pb back-color-fff content-pagination-box"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 20, 50, 100, 200]"
      :current-page="page.pageIndex"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.totalRows"
    >
    </el-pagination>
    <!-- <el-pagination class="pt pb back-color-fff" background @size-change="handleSizeChange"
      @current-change="handleCurrentChange" :page-sizes="[10, 50, 100, 200]" :current-page="page.pageIndex"
      :page-size="page.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="page.totalRows">
    </el-pagination> -->
    <el-drawer
      title="报货详情"
      :visible.sync="drawer"
      :direction="direction"
      size="35%"
    >
      <div class="delivery-details">
        <div class="pl30">
          <p class="t-left font-S16 pic-item">
            <img
              class="pic-w22 fl mr10"
              src="../../assets/images/clinic.png"
              alt=""
            />
            <b class="fl">
              {{ detailData.customerName || detailData.medName }}
            </b>
          </p>
          <p class="t-left font-S14 pic-item">
            <img
              class="pic-w22 fl mr10"
              src="../../assets/images/address.png"
              alt=""
            />
            <span class="fl">
              {{ detailData.address || detailData.medAddress || "-" }}
            </span>
          </p>
          <p class="t-left font-S14 pic-item">
            <img
              class="pic-w22 fl mr10"
              src="../../assets/images/date.png"
              alt=""
            />
            <span class="fl">{{ detailData.inputTime | getDate }}</span>
            <span class="ml15">{{ detailData.orderType }}</span>
          </p>
          <p
            class="t-left font-S14 pic-item"
            v-show="detailData.franchiseeName"
          >
            <img
              class="pic-w22 fl mr10"
              src="../../assets/images/company.png"
              alt=""
            />
            <span class="fl">{{ detailData.franchiseeName || "-" }}</span>
          </p>
        </div>
        <div class="variety-information">
          <div class="pl30">
            <p class="t-left font-S16"><b>品种信息</b></p>
            <div
              class="variety-list"
              v-for="(item, index) in detailData.orderDetailVOs"
              :key="index"
            >
              <div class="variety-left fl mr15">
                <img :src="item.goodsPictContent | filterImgUrl" alt="" />
              </div>
              <div class="variety-right">
                <p class="t-left font-S15">
                  <b>{{ item.goodsName }}</b>
                </p>
                <p class="t-left">{{ item.goodsSpec || "-" }}</p>
                <p class="t-left">{{ item.producer || "-" }}</p>
                <p v-show="item.goodsLotNo" class="t-left">
                  产品批号：{{ item.goodsLotNo }}
                </p>
                <p v-show="item.goodsProductDate" class="t-left">
                  生产日期：{{ item.goodsProductDate }}
                </p>
                <p v-show="item.goodsExpiryDate" class="t-left">
                  有效期：{{ item.goodsExpiryDate }}
                </p>
                <p class="t-left fontC-red">
                  ¥{{ item.price || 0 }}/{{ item.unitStyle }}
                </p>
              </div>
              <p class="t-right fontC-bcbec2">
                小计：数量 {{ item.qty | absoluteValue }} 金额：¥{{
                  item.amount | absoluteValue | numFmt | numDigit
                }}
              </p>
            </div>
            <p class="t-left total-top">
              共<b class="fontC-4fa1a4">{{ detailData.goodsSpecNum }} </b>个品种
              合计：
              <b class="fontC-red">
                ¥{{
                  detailData.totalAmount | absoluteValue | numFmt | numDigit
                }}
              </b>
            </p>
          </div>
        </div>
        <div class="offer-information pb">
          <div class="pl30">
            <p class="t-left font-S16"><b>单据信息</b></p>
            <p class="t-left font-S14">
              <span>单据编号：</span>{{ detailData.orderNo || "-" }}
            </p>
            <p class="t-left font-S14">
              <span>录入日期：</span>{{ detailData.inputTime | getDate }}
            </p>
            <p class="t-left font-S14">
              <span>制单人：</span>{{ detailData.createUserName || "-" }}
            </p>
            <p class="t-left font-S14">
              <span>备注：</span>{{ detailData.memo || "-" }}
            </p>
          </div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      contentMainHeight: window.innerHeight - 200,
      tableHeight: window.innerHeight - 263,
      searchShow: false,
      loading: false,
      showImport: false,
      page: {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        tenantGuid: "",
        startTime: "",
        endTime: "",
        customerName: "",
        taskMainGuid: "",
        taskDetailGuid: "",
      },
      orderTimeList: [],
      tableData: [],
      drawer: false,
      direction: "rtl",
      detailData: "",
      fullscreenLoading: false,
      orderSelectedList: [],
      tenantName: "",
      tenantGuid: "",
      multipleSelection: [],
    };
  },
  created() {
    this.getData();
  },
  methods: {
    empty() {
      this.orderTimeList = [];
      this.page = {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        tenantGuid: "",
        startTime: "",
        endTime: "",
        customerName: "",
        taskMainGuid: "",
        taskDetailGuid: "",
      };
      this.getData();
    },
    // 搜索
    search() {
      this.page.pageIndex = 1;
      this.getData();
    },
    async getData() {
      this.loading = true;
      this.page.tenantGuid = localStorage.guid;
      this.page.taskMainGuid = this.$route.query.taskMainGuid;
      this.page.taskDetailGuid = this.$route.query.taskDetailGuid;
      const params = {
        ...this.page,
        startTime: this.orderTimeList.length
          ? this.$moment(this.orderTimeList[0]).format("YYYY-MM-DD")
          : "",
        endTime: this.orderTimeList.length
          ? this.$moment(this.orderTimeList[1]).format("YYYY-MM-DD")
          : "",
        isDraft: "N",
      };
      const { data } = await this.api.postJson(
        `/${serverConfig.msPurchaseService}/sale-order/data/get`,
        params
      );
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message.error(data.msg);
        return;
      }
      this.$nextTick(() => {
        this.$refs.filterTable.doLayout();
      });
      this.loading = false;
      this.tableData = data.data.records || [];
      this.page.totalPage = data.data.totalPages;
      this.page.totalRows = data.data.totalRows;
    },
    //详情
    async detail(row) {
      let self = this;
      self.drawer = true;
      let path =
        row.tableType == "otc"
          ? "/order/data/get-order-detail?guid="
          : "/prescription-order/data/get-order-detail?guid=";
      const { data } = await self.api.get(
        `/${serverConfig.msPurchaseService}${path}` + row.guid
      );

      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        self.$message.error(data.msg);
        return;
      }
      self.detailData = data.data;
    },
    // 修改订单 1:药店,2商业公司,3医院
    toEdit(row) {
      let path = "";
      if (row.objectType == "1") {
        path = "/order";
      } else if (row.objectType == "2") {
        path = "/franchiseeOrder";
      } else if (row.objectType == "3") {
        path = "/rxOrder";
      }
      this.$router.push({
        path,
        query: {
          guid: row.guid,
          tenantGuid: this.$route.query.tenantGuid, // 任务包的 tenantGuid
          taskStartTime: this.$route.query.taskStartTime, // 任务包的开始时间
          taskEndTime: this.$route.query.taskEndTime, // 任务包的结束时间
          accountMonth: this.$route.query.accountMonth, // 核算月
        },
      });
    },
    //删除
    async delOrder(row, flg) {
      let self = this;
      let multipleSelection = self.multipleSelection;
      if (flg == 1) {
        if (self.multipleSelection.length == 0) {
          self.$message.error(messageConfig.DELETE_SELECT);
          return;
        }
      } else {
        // 单个删除
        multipleSelection = [];
        multipleSelection.push(row.guid);
      }
      let res = "";
      try {
        res = await this.$confirm(messageConfig.DELETE_AFTER, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        });
      } catch (e) {
        console.log(e);
      }
      // 取消了
      if (!res) {
        this.$message({
          type: "info",
          message: messageConfig.CANCEL_TIP,
        });
        return;
      }
      const path =
        this.tableData[0].tableType == "otc"
          ? "/order/data/delete"
          : "/prescription-order/data/delete";

      self.fullscreenLoading = true;
      const { data } = await self.api.postJson(
        `/${serverConfig.msPurchaseService}${path}`,
        multipleSelection
      );
      self.fullscreenLoading = false;
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        self.$message.error(data.msg);
        return;
      }
      self.$message.success(messageConfig.DELETE_SUCCESS);
      self.multipleSelection = [];
      self.page.pageIndex = 1;
      self.getData();
    },
    //选择记录
    handleSelectionChange(val) {
      this.multipleSelection = val.map((item) => item.guid);
    },

    handleSizeChange(val) {
      this.page.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      this.page.pageIndex = val;
      this.getData();
    },
  },
};
</script>
<style scoped>
.pic-w22 {
  width: 22px;
  height: 22px;
  /* padding-top: 6px; */
  /* box-sizing: border-box; */
}
.offer-information {
  border-top: 10px solid #dcdfe6;
  /* border-bottom: 10px solid #dcdfe6; */
}

.variety-information {
  /* padding-top: 10px; */
  border-top: 10px solid #dcdfe6;
}

.variety-list {
  padding: 15px;
  /* border-bottom: 1px solid #dcdfe6; */
  /* border-radius: 6px; */
  overflow: hidden;
}

.total-top {
  padding-top: 15px;
  border-top: 1px solid #dcdfe6;
}

.variety-left {
  width: 150px;
  height: 100px;
  margin-top: 20px;
  /* border-bottom: 1px solid #dcdfe6; */
  border-radius: 6px;
}

.variety-left img {
  width: 150px;
  height: 100px;
  border-radius: 6px;
}
.variety-right {
  margin-left: 164px;
}

.pic-item {
  overflow: hidden;
}

.importClass .secondStep {
  margin-top: 50px;
  height: 200px;
}

.importClass .secondStep .line1 {
  font-size: 20px;
}

.importClass .secondStep .line2 {
  font-size: 16px;
}

.importClass .secondStep .line2 span {
  color: #4fa1a4;
}

.importClass .secondStep .line3 {
  text-decoration: underline;
  cursor: pointer;
}

.upload-demo {
  display: inline-block;
  margin: 0 10px;
}

.task-tips {
  font-size: 14px;
  font-style: normal;
  font-weight: normal;
  color: red;
  text-align: left;
  margin-bottom: 5px;
  padding: 0 35px;
}

.tl {
  text-align: left;
}
/deep/ .el-drawer__body {
  overflow: auto;
  padding: 0 !important;
}
/deep/ .el-drawer__header {
  font-size: 18px;
  color: #333;
}
.search-area-div {
  flex-shrink: 0;
}
.ipt-sty {
  flex: 1;
}
.el-col-8 {
  display: flex;
  margin-bottom: 15px;
}
.headerStyle {
  background: #4fa1a4;
}
</style>
